import { type Router } from 'vue-router'

export function getParam(router: Router, paramToRetrieve: string) {
  return router?.currentRoute.value?.params?.[paramToRetrieve] as string
}
